import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStateService } from '../auth/auth-state.service';
import { FeatureFlagsService } from '../services/feature-flags.service';

/**
 * Client Payments — only when the server says showBilling === true.
 * Fail closed if flags are not loaded or not strictly true.
 */
export const clientBillingFeatureGuard: CanActivateFn = () => {
  if (inject(FeatureFlagsService).billingEnabled()) {
    return true;
  }
  return inject(Router).createUrlTree(['/app/smartfreight/rates']);
};

/**
 * Irish Taylor Billing overview — always for staff admins (holds the Billing toggle).
 * Not gated by showBilling.
 */
export const adminBillingOverviewGuard: CanActivateFn = () => {
  const auth = inject(AuthStateService);
  const router = inject(Router);
  const features = inject(FeatureFlagsService);
  const isAdmin = (auth.userRole() || '').toLowerCase() === 'admin';

  if (auth.isITStaff() && isAdmin) {
    return true;
  }

  if (isAdmin && features.billingEnabled()) {
    return router.createUrlTree(['/app/billing']);
  }
  return router.createUrlTree(['/app/smartfreight/rates']);
};

/** @deprecated Use clientBillingFeatureGuard */
export const billingFeatureGuard = clientBillingFeatureGuard;
